import Loading from "../../../Layouts/Loading";
import { useReviewAnswersQuery } from "../../../Redux/Apis/userExamApi";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useMemo } from "react";

function Review({userExamId,selectedOrder,onSelect}:any) {
    const {
        data,
        isLoading,
        isSuccess,
    } = useReviewAnswersQuery({ id: +userExamId })

    const rows = useMemo(
        () => {
            if (!isSuccess || !data) return []
            return [...data].sort((a, b) => a.order - b.order)
        },
        [data, isSuccess]
    )

    const getStatus = (row: any) => {
        const answer = row?.UserAnswers?.[0]?.answer
        if (answer && String(answer).trim() !== "") return "Answered"
        return "Not Answered"
    }

    const splitIndex = Math.ceil(rows.length / 2)
    const firstRows = rows.slice(0, splitIndex)
    const lastRows = rows.slice(splitIndex)

    return ( 
        <div dir="ltr" className="d-flex justify-content-center">
            <div
                className="bg-white"
                style={{
                    maxWidth: "960px",
                    width: "100%",
                    marginTop: "30px",
                    marginBottom: "30px",
                }}
            >
                <div className="d-flex justify-content-between align-items-start mb-2">
                    <div className="me-3" style={{fontSize:"13px", lineHeight:1.4, textAlign:"left"}}>
                        <h4 className="mb-3" style={{fontSize:"20px", fontWeight:600}}>Review</h4>
                        <p className="mb-2">
                            This page presents information about questions in the exam. You may sort the questions by <b>Number</b>, <b>Status</b>, and
                            <b> Marked</b>. Questions you have encountered have a status of <b>Answered</b>, <b>Incomplete</b>, or <b>Not Answered</b>. An <b>Incomplete</b> status
                            indicates you have selected more or fewer options than the question requires. Questions you have not encountered have a status of
                            <b> Not Encountered</b>. Marked questions are indicated with a check mark in the <b>Marked</b> column.
                        </p>
                        <p className="mb-0">
                            To return to the question you were on, select <b>Return</b>. To go to a different question, select that question and select <b>Go to Question</b>.
                            You will be unable to go to questions that have a status of <b>Not Encountered</b>.
                        </p>
                    </div>
                    <div className="d-flex flex-column align-items-stretch" style={{gap:"8px", marginLeft:"16px"}}></div>
                </div>
                <hr className="mt-3 mb-3" style={{borderTop:"1px solid #000"}} />
                {isLoading && <Loading />}
                {isSuccess && rows.length > 0 && (
                    <div className="py-2" style={{maxHeight:"55vh",overflowY:"auto", fontSize:"12px"}}>
                        <div className="row gx-4">
                            <div className="col-md-6 mb-3">
                                <p className="text-center mb-2" style={{fontWeight:600}}>
                                    First {firstRows.length} Rows Sorted by Number in Ascending Order
                                </p>
                                <div className="table-responsive">
                                    <table className="table table-sm mb-0" style={{borderCollapse:"collapse"}}>
                                        <thead>
                                            <tr>
                                                <th
                                                    className="text-center"
                                                    style={{
                                                        width:"25%",
                                                        backgroundColor:"#f1e3c1",
                                                        border:"1px solid #000",
                                                        padding:"4px"
                                                    }}
                                                >
                                                    Number
                                                </th>
                                                <th
                                                    className="text-center"
                                                    style={{
                                                        width:"45%",
                                                        backgroundColor:"#f1e3c1",
                                                        border:"1px solid #000",
                                                        padding:"4px"
                                                    }}
                                                >
                                                    Status
                                                </th>
                                                <th
                                                    className="text-center"
                                                    style={{
                                                        width:"30%",
                                                        backgroundColor:"#f1e3c1",
                                                        border:"1px solid #000",
                                                        padding:"4px"
                                                    }}
                                                >
                                                    Marked
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {firstRows.map((row:any, index:number) => {
                                                const globalIndex = index + 1
                                                const isSelected = selectedOrder === Number(row.order)
                                                return (
                                                    <tr
                                                        key={row.order}
                                                        style={{ cursor:"pointer" }}
                                                        onClick={() => onSelect(Number(row.order))}
                                                    >
                                                        <td
                                                            className="text-center align-middle"
                                                            style={{
                                                                border:"1px solid #000",
                                                                padding:"3px 4px",
                                                                backgroundColor: isSelected ? "#99c2ff" : "#fff"
                                                            }}
                                                        >
                                                            {globalIndex}
                                                        </td>
                                                        <td
                                                            className="text-center align-middle"
                                                            style={{
                                                                border:"1px solid #000",
                                                                padding:"3px 4px",
                                                                backgroundColor: isSelected ? "#99c2ff" : "#fff"
                                                            }}
                                                        >
                                                            {getStatus(row)}
                                                        </td>
                                                        <td
                                                            className="text-center align-middle"
                                                            style={{
                                                                border:"1px solid #000",
                                                                padding:"3px 4px",
                                                                backgroundColor: isSelected ? "#99c2ff" : "#fff"
                                                            }}
                                                        >
                                                            {row.Pins.length > 0 && (
                                                                <span className="text-warning">
                                                                    <FontAwesomeIcon icon="star" />
                                                                </span>
                                                            )}
                                                        </td>
                                                    </tr>
                                                )
                                            })}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div className="col-md-6 mb-3">
                                <p className="text-center mb-2" style={{fontWeight:600}}>
                                    Last {lastRows.length} Rows Sorted by Number in Ascending Order
                                </p>
                                <div className="table-responsive">
                                    <table className="table table-sm mb-0" style={{borderCollapse:"collapse"}}>
                                        <thead>
                                            <tr>
                                                <th
                                                    className="text-center"
                                                    style={{
                                                        width:"25%",
                                                        backgroundColor:"#f1e3c1",
                                                        border:"1px solid #000",
                                                        padding:"4px"
                                                    }}
                                                >
                                                    Number
                                                </th>
                                                <th
                                                    className="text-center"
                                                    style={{
                                                        width:"45%",
                                                        backgroundColor:"#f1e3c1",
                                                        border:"1px solid #000",
                                                        padding:"4px"
                                                    }}
                                                >
                                                    Status
                                                </th>
                                                <th
                                                    className="text-center"
                                                    style={{
                                                        width:"30%",
                                                        backgroundColor:"#f1e3c1",
                                                        border:"1px solid #000",
                                                        padding:"4px"
                                                    }}
                                                >
                                                    Marked
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {lastRows.map((row:any, index:number) => {
                                                const globalIndex = splitIndex + index + 1
                                                const isSelected = selectedOrder === Number(row.order)
                                                return (
                                                    <tr
                                                        key={row.order}
                                                        style={{ cursor:"pointer" }}
                                                        onClick={() => onSelect(Number(row.order))}
                                                    >
                                                        <td
                                                            className="text-center align-middle"
                                                            style={{
                                                                border:"1px solid #000",
                                                                padding:"3px 4px",
                                                                backgroundColor: isSelected ? "#99c2ff" : "#fff"
                                                            }}
                                                        >
                                                            {globalIndex}
                                                        </td>
                                                        <td
                                                            className="text-center align-middle"
                                                            style={{
                                                                border:"1px solid #000",
                                                                padding:"3px 4px",
                                                                backgroundColor: isSelected ? "#99c2ff" : "#fff"
                                                            }}
                                                        >
                                                            {getStatus(row)}
                                                        </td>
                                                        <td
                                                            className="text-center align-middle"
                                                            style={{
                                                                border:"1px solid #000",
                                                                padding:"3px 4px",
                                                                backgroundColor: isSelected ? "#99c2ff" : "#fff"
                                                            }}
                                                        >
                                                            {row.Pins.length > 0 && (
                                                                <span className="text-warning">
                                                                    <FontAwesomeIcon icon="star" />
                                                                </span>
                                                            )}
                                                        </td>
                                                    </tr>
                                                )
                                            })}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}

export default Review;
